import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import { Tracker } from "@araneadev/usage-tracker-sdk";

new Tracker({
  apiKey: process.env.REACT_APP_USAGE_TRACKER_API_KEY,
  endpoint: 'https://ut.aranea.dev/ingest',
});

ReactDOM.render(<App />, document.getElementById('root'));
unregister();
